"use client";
import Image from "next/image";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import NavButton from "../go-back-components/nav-button";
import { useTranslations } from "next-intl";
import { useState } from "react";

type PortfolioProps = {
  name: string;
  description: string;
  imgUrl: string;
  imgAlt: string;
  navUrl: string;
  date?: string;
  projectType?: string;
};

export function PortFolioCard({
  name,
  description,
  imgUrl,
  imgAlt,
  navUrl,
  projectType,
  date,
}: PortfolioProps) {
  const t = useTranslations("Components.navigation");
  const [loaded, setLoaded] = useState(false);

  return (
    <div className=" flex-1 relative bg-primary-grey flex flex-col rounded-md overflow-hidden w-full min-w-xs transition-transform">
      <Image
        src={imgUrl}
        alt={imgAlt}
        fill
        sizes="200px"
        className={`object-cover transition-opacity duration-500  ${
          loaded ? "opacity-100" : "opacity-0 "
        }`}
        onLoad={() => setLoaded(true)}
      />
      <div className="absolute inset-0 bg-background-grey/80" />

      <div className="relative z-10 flex flex-col justify-between gap-5 p-10 text-white h-full">
        <div>
          <h2>{name}</h2>
          <p>{description}</p>
          <p className="text-xs pt-2">
            {projectType} {date && projectType ? "·" : ""} {date}
          </p>
        </div>

        <NavButton icon={faArrowRight} url={navUrl} text={t("seeMore")} />
      </div>
    </div>
  );
}
